/**
 * Stacja metra → dzielnica. Do pokazywania stacji W KONTEKŚCIE wybranej dzielnicy
 * (nakładka wyboru obszaru na telefonie), a nie jako chmura wszystkich stacji naraz.
 *
 * WYGENEROWANE Z PLIKU `warsawMetro.ts`, nie z pamięci — i to jest tu najważniejsze
 * zdanie. Pierwsza wersja (fd34c9d7) powstała z listy stacji, którą WPISAŁEM RĘCZNIE
 * zamiast wczytać: miała trzy nazwy, których w `WARSAW_METRO` nie ma (`Stare Bemowo`,
 * `Praga`, `Powstańców Śląskich`) i gubiła dwie, które są (`Słodowiec`,
 * `Stare Bielany`) — więc po dotknięciu Bielan kontekst był niepełny. Nagłówek
 * twierdził przy tym, że zapytanie przeszło po `WARSAW_METRO`, co nie było prawdą.
 * Test obok pilnuje teraz zgodności w OBIE strony, żeby rozjazd nie mógł wrócić.
 *
 * Przypisanie policzone geometrią: `ST_Contains` wobec rejonów MSI
 * (`flat.warsaw_msi_rejony.geom`), współrzędne prosto z `warsawMetro.ts`. Wszystkie
 * 38 stacji trafiły WEWNĄTRZ rejonu — żadna nie wymagała przybliżenia
 * „najbliższy rejon", więc nic tu nie jest zgadnięte. Zapytanie generujące:
 *
 *   with s(nazwa, lat, lon) as (values …)   -- wartości wczytane z warsawMetro.ts
 *   select s.nazwa,
 *          (select r.dzielnica from flat.warsaw_msi_rejony r
 *           where st_contains(r.geom, st_setsrid(st_makepoint(s.lon, s.lat), 4326)) limit 1)
 *   from s order by 1;
 *
 * Dlaczego plik statyczny, a nie zapytanie w locie: nakładka ma się otworzyć natychmiast
 * po dotknięciu pola, a przypisanie zmienia się raz na kilka lat — przy budowie nowej
 * stacji, czyli wtedy, gdy i tak trzeba ją dopisać do `WARSAW_METRO` i przegenerować to.
 */
export const WARSAW_METRO_DISTRICT: Record<string, string> = {
  'Bemowo': 'Bemowo',
  'Bródno': 'Targówek',
  'Centrum': 'Śródmieście',
  'Centrum Nauki Kopernik': 'Śródmieście',
  'Dworzec Gdański': 'Śródmieście',
  'Dworzec Wileński': 'Praga-Północ',
  'Imielin': 'Ursynów',
  'Kabaty': 'Ursynów',
  'Kondratowicza': 'Targówek',
  'Księcia Janusza': 'Wola',
  'Marymont': 'Żoliborz',
  'Młociny': 'Bielany',
  'Młynów': 'Wola',
  'Natolin': 'Ursynów',
  'Nowy Świat-Uniwersytet': 'Śródmieście',
  'Plac Wilsona': 'Żoliborz',
  'Płocka': 'Wola',
  'Pole Mokotowskie': 'Mokotów',
  'Politechnika': 'Śródmieście',
  'Racławicka': 'Mokotów',
  'Ratusz Arsenał': 'Śródmieście',
  'Rondo Daszyńskiego': 'Wola',
  'Rondo ONZ': 'Wola',
  'Słodowiec': 'Bielany',
  'Służew': 'Mokotów',
  'Stadion Narodowy': 'Praga-Północ',
  'Stare Bielany': 'Bielany',
  'Stokłosy': 'Ursynów',
  'Świętokrzyska': 'Śródmieście',
  'Szwedzka': 'Praga-Północ',
  'Targówek Mieszkaniowy': 'Targówek',
  'Trocka': 'Targówek',
  'Ulrychów': 'Wola',
  'Ursynów': 'Ursynów',
  'Wawrzyszew': 'Bielany',
  'Wierzbno': 'Mokotów',
  'Wilanowska': 'Mokotów',
  'Zacisze': 'Targówek',
};
